import useInfiniteScroll from '@/hooks/useInfiniteScroll';

interface InfiniteListQuery<TItem> {
  readonly data:
    | { pages: ReadonlyArray<{ data: readonly TItem[] }> }
    | undefined;
  readonly isLoading: boolean;
  readonly isFetching: boolean;
  readonly isError: boolean;
  readonly hasNextPage: boolean;
  readonly fetchNextPage: () => unknown;
}

/**
 * Flattens an infinite query's pages and wires up the load-more sentry —
 * shared by the four filter list components.
 */
export function useInfiniteFilterList<TItem>(query: InfiniteListQuery<TItem>) {
  const { data, isLoading, isFetching, isError, hasNextPage, fetchNextPage } =
    query;

  const items = data?.pages.flatMap((page) => page.data) ?? [];

  const [sentryRef] = useInfiniteScroll({
    loading: isFetching,
    hasNextPage,
    onLoadMore: fetchNextPage,
    disabled: isError,
    rootMargin: '0px 0px 100px 0px',
  });

  return { items, isLoading, hasNextPage, sentryRef };
}
